import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../components/Logo';

// Thank-you page is Italian only (per requirements).
export default function ThankYou() {
  const t = {
    eyebrow: 'Grazie',
    title: 'Il tuo messaggio è stato inviato correttamente.',
    body: 'Abbiamo ricevuto la tua richiesta. Il team di Auronixio ti ricontatterà nel più breve tempo possibile per rispondere alle tue domande e accompagnarti nei prossimi passi.',
    back: 'Torna alla home',
    company: 'Auronixio S.r.l. — Milano, Italia',
  };

  return (
    <div className="auro-thanks">
      <div className="auro-thanks__bg" aria-hidden="true" />
      <div className="auro-container auro-thanks__card">
        <div className="auro-thanks__logo"><Logo /></div>
        <span className="auro-eyebrow">{t.eyebrow}</span>
        <h1 className="auro-h1 auro-h1--thanks">{t.title}</h1>
        <p className="auro-lead">{t.body}</p>
        <Link to="/" className="auro-btn auro-btn--primary auro-btn--lg" data-testid="back-home">
          ← {t.back}
        </Link>
        <p className="auro-thanks__foot">{t.company}</p>
      </div>
    </div>
  );
}
